do () ->

    require('./array')
    require('./classlist')
    require('./importnode')
    history = require('html5-history-api')
    #console.log(history)

    return
